import React, { useContext, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { UserContext } from "../userContext/userContext.js";
import PageLayout from "../layout/PageLayout";

// import Login from "../pages/Login";
// import HomeAdmin from "../pages/HomeAdmin";
import GestionAdmin from "../pages/GestionAdmin";
import StatistiqueAdmin from "../pages/StatistiqueAdmin";
import GalerieAdmin from "../pages/GalerieAdmin";
import SelectGalerieAdmin from "../pages/SelectGalerieAdmin";
import GaleriePublicAdmin from "../pages/GaleriePublicAdmin.js";
import GalerieMembersAdmin from "../pages/GalerieMembersAdmin.js";
import MembresAdmin from "../pages/MembresAdmin.js";
import QsnAdmin from "../pages/QsnAdmin.js";
import EvenementsAdmin from "../pages/EvenementsAdmin";
import EvenementsMembers from "../pages/EvenementsMembers";
import FileLinkGenerationAdmin from "../pages/FileLinkGenerationAdmin.js";
import CARepositoryAdmin from "../pages/CARepositoryAdmin.js";
import CARepositoryMembers from "../pages/CARepositoryMembers.js";
import GalerieMembers from "../pages/GalerieMembers";
import PartenairesAdmin from "../pages/PartenairesAdmin";
import AdhesionAdmin from "../pages/AdhesionAdmin";
import ContactAdmin from "../pages/ContactAdmin";
import EvenementsMembersIncoming from '../pages/EvenementsMembersIncoming';
import EvenementsMembersPasses from '../pages/EvenementsMembersPasses';
import EvenementsMembersExternal from '../pages/EvenementsMembersExternal';

const ProtectedApp = () => {
	const {
		userState,
		userDispatch,
	} = useContext(UserContext);
	if (!userState?.isLogged) return <Redirect to="/" />;
	return (
		<Switch>
			{/* <Route exact path="/" component={Login} /> */}
			

			{(userState && userState.userConnected && userState.userConnected.role === 2) && <PageLayout
				userState={userState}
				userDispatch={userDispatch}>
				{/* <Route exact path="/admin/home" component={HomeAdmin}/> */}
				<Route exact path="/admin/gestion" component={GestionAdmin}/>
				<Route exact path="/admin/statistique" component={StatistiqueAdmin}/>
				<Route exact path="/admin/gestion/membres" component={MembresAdmin}/>
				<Route exact path="/admin/gestion/galerie" component={SelectGalerieAdmin}/>
				<Route exact path="/admin/gestion/galerie/members" component={GalerieMembersAdmin}/>
				<Route exact path="/admin/gestion/galerie/public" component={GaleriePublicAdmin}/>
				<Route exact path="/admin/gestion/evenements" component={EvenementsAdmin}/>
				<Route exact path="/admin/gestion/contact" component={ContactAdmin}/>
				<Route exact path="/admin/gestion/partenaires" component={PartenairesAdmin}/>
				<Route exact path="/admin/gestion/adhesion" component={AdhesionAdmin}/>
				<Route exact path="/admin/gestion/qsn" component={QsnAdmin}/>
				<Route exact path="/admin/gestion/espaceca" component={CARepositoryAdmin}/>
				<Route exact path="/admin/file/link" component={FileLinkGenerationAdmin}/>
			</PageLayout>}
			{(userState && userState.userConnected && userState.userConnected.role === 1) &&<PageLayout
				userState={userState}
				userDispatch={userDispatch}>
				{/* <Route exact path="/ca/home" component={ActivitesMembers}/> */}
				{/* <Route exact path="/ca/gestion" component={GestionAdmin}/> */}
				<Route exact path="/ca/home" component={GalerieMembers}/>
				<Route exact path="/ca/galerie" component={GalerieMembers}/>
				<Route exact path="/ca/evenements/a-venir" component={EvenementsMembersIncoming}/>
				<Route exact path="/ca/evenements/passes" component={EvenementsMembersPasses}/>
				<Route exact path="/ca/evenements/external" component={EvenementsMembersExternal}/>
				<Route exact path="/ca/crca" component={CARepositoryMembers}/>

			</PageLayout>}
			
		</Switch>
	);
};

export default ProtectedApp;
